module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4  text-center"
  }, [_vm._v(_vm._s(_vm.communityDetails.name))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.communityDetails.logoUrl) ? _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "240px"
    },
    attrs: {
      "src": _vm.communityDetails.logoUrl
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('community.tag')))]), _vm._v(" "), _c('p', [_vm._v("[" + _vm._s(_vm.communityDetails.tag) + "]")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v("Website")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionalCommunityWebsite)
    }
  })])]), _vm._v(" "), (_vm.isCommunityMember || _vm.isCommunityAdmin) ? _c('div', {
    staticClass: "row text-center"
  }, [(_vm.communityDetails.gameServers) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('community.gameServers')))]), _vm._v(" "), _vm._l((_vm.communityDetails.gameServers), function(gameServer, index) {
    return _c('div', {
      key: ((gameServer.hostname) + ":" + (gameServer.port)),
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(gameServer.hostname))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(gameServer.port))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(gameServer.name) ? _c('span', [_vm._v(_vm._s(gameServer.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(gameServer.password) ? _c('span', [_vm._v(_vm._s(gameServer.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), (index < _vm.communityDetails.gameServers.length - 1) ? _c('br') : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.communityDetails.voiceComms) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('community.voiceComms')))]), _vm._v(" "), _vm._l((_vm.communityDetails.voiceComms), function(voiceComms, index) {
    return _c('div', {
      key: ((voiceComms.hostname) + ":" + (voiceComms.port)),
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(voiceComms.hostname))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(voiceComms.port))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(voiceComms.name) ? _c('span', [_vm._v(_vm._s(voiceComms.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(voiceComms.password) ? _c('span', [_vm._v(_vm._s(voiceComms.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), (index < _vm.communityDetails.gameServers.length - 1) ? _c('br') : _vm._e()])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.communityDetails.repositories) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.communityDetails.repositories) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.communityRepositoriesCollapse",
      modifiers: {
        "communityRepositoriesCollapse": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.repository.list')) + "\n          ")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "communityRepositoriesCollapse"
    }
  }, [(_vm.communityDetails.repositories.length === 0) ? _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-italic text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.repository.list.empty')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.communityRepositoryChunks), function(chunk, chunkIndex) {
    return _c('div', {
      key: chunk
    }, [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._l((chunk), function(communityRepository, index) {
      return _c('div', {
        key: communityRepository,
        staticClass: "col"
      }, [(communityRepository.name) ? _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.name')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4"
      }, [_vm._v(_vm._s(communityRepository.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.url')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(communityRepository.url) ? _c('span', [(communityRepository.kind === 'arma3sync') ? _c('a', {
        attrs: {
          "href": communityRepository.url
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.$copyText(communityRepository.url)
          }
        }
      }, [_vm._v(_vm._s(communityRepository.url))]) : _c('a', {
        attrs: {
          "href": communityRepository.url
        }
      }, [_vm._v(_vm._s(communityRepository.url))])]) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.notes')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(communityRepository.notes) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(communityRepository.notes)
        }
      }) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('b-btn', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (communityRepository.url),
          expression: "communityRepository.url",
          arg: "copy"
        }],
        attrs: {
          "size": "sm",
          "disabled": !communityRepository.url
        }
      }, [_c('i', {
        staticClass: "fa fa-clipboard",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n                    ")]), _vm._v(" "), (_vm.canEditCommunity) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.canEditCommunity) ? _c('b-btn', {
        attrs: {
          "size": "sm",
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeCommunityRepository(chunkIndex * 2 + index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.remove')) + "\n                    ")]) : _vm._e()], 1)])
    }), _vm._v(" "), (chunk.length === 1) ? _c('div', {
      staticClass: "col"
    }) : _vm._e()], 2)])
  }), _vm._v(" "), (_vm.canEditCommunity) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.name.required'),
      "state": _vm.communityRepositoryCreateNameState,
      "feedback": _vm.communityRepositoryCreateNameFeedback,
      "description": _vm.$t('mission.repository.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityRepositoryCreateData.name),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.name = $$v
      },
      expression: "communityRepositoryCreateData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.kind'),
      "state": _vm.communityRepositoryCreateKindState,
      "feedback": _vm.communityRepositoryCreateKindFeedback,
      "description": _vm.$t('mission.repository.kind.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.communityRepositoryCreateKindOptions
    },
    model: {
      value: (_vm.communityRepositoryCreateData.kind),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.kind = $$v
      },
      expression: "communityRepositoryCreateData.kind"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.url.optional'),
      "state": _vm.communityRepositoryCreateUrlState,
      "feedback": _vm.communityRepositoryCreateUrlFeedback,
      "description": _vm.$t('mission.repository.url.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityRepositoryCreateData.url),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.url = $$v
      },
      expression: "communityRepositoryCreateData.url"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.notes.optional'),
      "state": _vm.communityRepositoryCreateNotesState,
      "feedback": _vm.communityRepositoryCreateNotesFeedback,
      "description": _vm.$t('mission.repository.notes.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.communityRepositoryCreateData.notes),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.notes = $$v
      },
      expression: "communityRepositoryCreateData.notes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.createCommunityRepository
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n                  ")])], 1)])]) : _vm._e()], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditCommunity),
      expression: "canEditCommunity"
    }],
    staticClass: "my-4"
  }), _vm._v(" "), (_vm.canEditCommunity) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.communityEditModal",
      modifiers: {
        "communityEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.communityLogoModal",
      modifiers: {
        "communityLogoModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.community.logo')) + "\n        ")]), _vm._v(" \n        "), (_vm.isCommunityFounder) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.communityPermissionModal",
      modifiers: {
        "communityPermissionModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.community.permissions')) + "\n        ")]) : _vm._e(), _vm._v(" \n        "), (_vm.isCommunityFounder) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "messages": {
        title: _vm.$t('community.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('nav.missions')))]), _vm._v(" "), _c('community-missions')], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('community.members')))]), _vm._v(" "), _c('community-members')], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.canEditCommunityMembers) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('community.applications')))]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('community.applications.filter'),
      "label-for": "communityApplicationsFilter"
    }
  }, [_c('div', {
    attrs: {
      "role": "group",
      "id": "communityApplicationsFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "processed",
      "value": "processed"
    },
    model: {
      value: (_vm.communityApplicationsFilter),
      callback: function($$v) {
        _vm.communityApplicationsFilter = $$v
      },
      expression: "communityApplicationsFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('community.applications.filter.processed')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "accepted",
      "value": "accepted"
    },
    model: {
      value: (_vm.communityApplicationsFilter),
      callback: function($$v) {
        _vm.communityApplicationsFilter = $$v
      },
      expression: "communityApplicationsFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('community.applications.filter.accepted')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "denied",
      "value": "denied"
    },
    model: {
      value: (_vm.communityApplicationsFilter),
      callback: function($$v) {
        _vm.communityApplicationsFilter = $$v
      },
      expression: "communityApplicationsFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('community.applications.filter.denied')) + "\n              ")])], 1)])], 1), _vm._v(" "), _c('community-applications')], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [(_vm.canEditCommunity) ? _c('community-edit-modal') : _vm._e(), _vm._v(" "), (_vm.canEditCommunity) ? _c('community-logo-modal') : _vm._e(), _vm._v(" "), (_vm.isCommunityFounder) ? _c('community-permission-modal') : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c9b0881"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommunityDetails.vue
// module id = 527
// module chunks = 0